/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameContainer',['pixi', 'absolute/spriteutils', 'Arkadium/GameEngine/Core/EngineManagers', 'Arkadium/GameEngine/Scenes/Nodes/SpriteNode', 'Managers/KeyboardManager'],
    function (PIXI, SpriteUtils, EngineManagers, SpriteNode, KeyboardManager) {
    "use strict";

    var GameContainer = function (game) {
        this.initGameContainer(game);
    };

    GameContainer.prototype = Object.create(SpriteNode.prototype);
    GameContainer.prototype.constructor = GameContainer;


    GameContainer.prototype.initGameContainer = function (game) {
        SpriteNode.call(this);
        this.game = game;
        this.background = null;
        this.supplyView = null;
        this.endGameAnimator = null;
        this.endGameBackground = null;
        this.inputInterceptOverlay = null;
    };

    GameContainer.prototype.setBackground = function (background) {
        this.background = background;
        this.addChildAt(this.background, 0);
    };

    GameContainer.prototype.removeBackground = function () {
        this.removeChild(this.background);
        this.background = null;
    };

    GameContainer.prototype.setSupplyView = function (supplyView) {
        this.supplyView = supplyView;
        this.addChildAt(this.supplyView, this.children.indexOf(this.background) + 1);
        this.supplyView.initForceSprite()
    };

    GameContainer.prototype.removeSupplyView = function () {
        this.removeChild(this.supplyView);
        this.supplyView = null;
    };

    GameContainer.prototype.setEndGameAnimator = function (endGameAnimator, endGameBackground, endCallback) {
        this.endGameAnimator = endGameAnimator;
        this.endGameBackground = endGameBackground;
        endGameBackground.x = -EngineManagers.Display.Width / 2;
        endGameBackground.y = -EngineManagers.Display.Height / 2;
        this.supplyView.addChildAt(this.endGameBackground, this.supplyView.children.indexOf(this.supplyView.pileBackgroundContainer) + 1);
        this.addChildAt(this.endGameAnimator, this.children.indexOf(this.supplyView) + 1);
        this.inputInterceptOverlay = new PIXI.Graphics();
        this.inputInterceptOverlay.beginFill(0x000001, 0);
        this.inputInterceptOverlay.drawRect(0, 0, EngineManagers.Display.Width, EngineManagers.Display.Width);
        this.inputInterceptOverlay.endFill();
        this.inputInterceptOverlay.interactive = true;
        this.inputInterceptOverlay.hitArea = new PIXI.Rectangle(0, 0, EngineManagers.Display.Width, EngineManagers.Display.Width);
        SpriteUtils.bindInteraction(this.inputInterceptOverlay, function () {
            endCallback();
        }.bind(this));
        this.addChild(this.inputInterceptOverlay);
        this.game.menuBar.setBackHandler(function () {
            endCallback();
        });
        this.game.gameScreenUI.hideButtons();
        KeyboardManager.setAnyKeyHandler(function () {
            endCallback();
        }.bind(this));
    };

    GameContainer.prototype.removeEndGameAnimator = function () {
        this.removeChild(this.inputInterceptOverlay);
        this.supplyView.removeChild(this.endGameBackground);
        this.removeChild(this.endGameAnimator);
        this.inputInterceptOverlay = null;
        this.endGameBackground = null;
        this.endGameAnimator = null;
        this.game.menuBar.removeBackHandler();
        KeyboardManager.removeAnyKeyHandler();
    };


    return GameContainer;


});

